module.exports = __webpack_public_path__ + "assets/intro-bg-720-x-1516.410ce130.svg";